import React, { useState, useEffect } from 'react'
import { GetCmsPages } from '../api.services.js/others'
import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Form, Row } from 'react-bootstrap';
import config from '../config';
import Head from 'next/head';
import { gtagConversionEvent } from '../gtag';



export const getServerSideProps=async ()=>{
  const {data}=await GetCmsPages({identifier:"projects-at-orientbell"})
  return {
    props:{data},
  }
}

function ProjectsAtOrientbell(props) {
   const [cmsPage, setcmsPage] = useState(props.data.cmsPage.content);
    const [name, setName] = useState('');
   const [phone, setPhone] = useState('');
   const [state, setState] = useState('');
   const [city, setCity] = useState('');
   const [subject, setSubject] = useState('');
   const [email, setEmail] = useState('');
   const [message, setMessage] = useState('');
   const [loading, setLoading] = useState(false)
  
   const [indianStates, setIndianStates] = useState([
     "Andhra Pradesh",
     "Arunachal Pradesh",
     "Assam",
     "Bihar",
     "Chhattisgarh",
     "Goa",
     "Gujarat",
     "Haryana",
     "Himachal Pradesh",
     "Jharkhand",
     "Karnataka",
     "Kerala",
     "Madhya Pradesh",
     "Maharashtra",
     "Manipur",
     "Meghalaya",
     "Mizoram",
     "Nagaland",
     "Odisha",
     "Punjab",
     "Rajasthan",
     "Sikkim",
     "Tamil Nadu",
     "Telangana",
     "Tripura",
     "Uttar Pradesh",
     "Uttarakhand",
     "West Bengal",
     "Andaman and Nicobar Islands",
     "Chandigarh",
     "Dadra and Nagar Haveli",
     "Daman and Diu",
     "Lakshadweep",
     "Delhi",
     "Puducherry"
   ]);
 
   // Function to handle form submission
   const handleSubmit = async (e) => {
     e.preventDefault();
     //gtagConversionEvent()
     setLoading(true)
     let response = await contactUs({
         name,
       phone,
       state,
       city,
       subject,
       email,
       message,
     })
     if(response.message){
         swal(response.message)
         setLoading(false)
     } else {
         swal(response.data.contact_us.msg)
         setLoading(false)
         setMessage('')
         setEmail('')
         setSubject('')
         setCity('')
         setState('')
         setPhone('')
         setName('')
     }
    }

  const appendBaseUrlToSrc = (htmlContent) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlContent;
    const imgElements = tempElement.querySelectorAll('img');
    imgElements.forEach((img) => {
      const src = img.getAttribute('src');
      if (src && !src.startsWith('http')) {
        img.setAttribute('src', config.API_ENDPOINT + src);
      }
    });

    setcmsPage(tempElement.innerHTML);
  };

  useEffect(()=>appendBaseUrlToSrc(props.data.cmsPage.content))
 

  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Projects At OrientBell",
        "item": "https://www.orientbell.com/projects-at-orientbell"
      }]
      }`
    }
  }
  return (
    <>
    <Head>
    <meta name="keywords" content="large tile projects, tile projects, large tiling projects, large scale tiling projects, large tile solutions, orientbell large tiling projects, orientbell tile projects, orientbell big projects, orientbell tiles solution"></meta>
    <meta name="description" content="Know about the large scale tiling projects by Orientbell in India. Orientbell provides innovative tile solutions for residential, commercial and government projects."></meta>
    <meta name="title" content="Orientbell's Large Tiling Projects in India - Orientbell Tiles"></meta>
    <title> Orientbell&apos;s Large Tiling Projects in India - Orientbell Tiles</title>
    <script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>

    </Head>
    <div className='projects_at_orientbell_page'>
    <Container>
      <Breadcrumb>
      <BreadcrumbItem href='/'>Home</BreadcrumbItem> 
      <BreadcrumbItem href='#'>Projects at OrientBell</BreadcrumbItem>
      </Breadcrumb>
    <div dangerouslySetInnerHTML={{__html:cmsPage}}></div>

    <div className='contactus_data'>
    <div className='contactus_data_con  custom_div_in_projectatobl'>
         <div className="g-heading">Orient Bell Limited</div>
              <p><strong>Corporate Office</strong></p>
              <p>Iris House, 16 Business Centre, Nangal Raya, DDA<br />Complex, New Delhi – 110046 (India)CIN:<br />L14101UP1977PLC021546<br /><span>Call Toll Free: 1800 208 1015</span></p>
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14010.547172741708!2d77.109074!3d28.610671!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1cacbfffffff%3A0x9bb8058abbee3f44!2sOrientbell%20Tiles%20Corporate%20Office!5e0!3m2!1sen!2sin!4v1688019901499!5m2!1sen!2sin" width="100%" height="auto"></iframe>
            </div>
            <div className='contactus_data_con  custom_div_in_projectatobl'>
             <div className="g-heading">Enquiry</div>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Form.Group className="mb-4" as={Col} lg="6" controlId="validationCustom01">
                    <Form.Control
                      type="text"
                      placeholder="Full Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-4" as={Col} lg="6" controlId="validationCustom02">
                    <Form.Control
                      type="number"
                      placeholder="Your Contact"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      min={10}
                      required
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mb-4" as={Col} lg="6" controlId="validationCustom01">
                    <Form.Select
                      aria-label="Default select example"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      required
                    >
                      <option value="">State</option>
                      {indianStates.sort().map((cur, iiiin)=>{
                  return(
                <option key={iiiin} value={cur}>{cur}</option>
                )
                })}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-4" as={Col} lg="6" controlId="validationCustom02">
                    <Form.Control
                      type="text"
                      placeholder="Your City"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mb-4" as={Col} lg="6" controlId="validationCustom01">
                    <Form.Select
                      aria-label="Default select example"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      required
                    >
                        <option value="">Select Your Enquiry</option><option value="Home">Home</option>
                        <option value="Commercial/Business">Commercial/Business</option>
                        <option value="Others">Others</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-4" as={Col} lg="6" controlId="validationCustom02">
                    <Form.Control
                      type="email"
                      placeholder="Email:"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mb-4">
                    <Form.Control
                      as="textarea"
                      placeholder="Your Message"
                      style={{ height: '100px' }}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Row>
                <div className='contactus_bottom_form'>
                  <Form.Group>
                    <Form.Check
                      label="I have read and agree to Orientbell's Privacy Policy"
                      feedback="You must agree before submitting."
                      feedbackType="invalid"
                      required
                    />
                  </Form.Group>
                 
                  
                </div>
                {
                    loading ? <Button  variant="secondary">Submitting</Button>:
                    <Button type="submit" variant="primary">Submit</Button>
                  }
              </Form>
            </div>
          </div>

          <div className="salesOffice custom_div_in_projectatobl">
          <div className="g-heading">Our regional sales team contact details</div>
            <div className="tabber regio-Tab largeRegion">
            <ul>
              <li><a className="actv" onclick="tab(0)" href="javascript:;">REGION<span>North</span></a></li>
            </ul>
            </div>
          <div className="tabContent">
          <div className="regionContent largeDetail">
          <ul className="regionDetails">
            <li><span>Delhi-NCR</span><span>Neeraj Verma</span>8373914445</li>
            <li><span>Mumbai</span><span>Pramod Kumar Singh</span>8879743933</li>
            <li><span>Bengaluru</span><span>Viswa Mohan Rath</span>8884450391</li>
            <li><span>Kolkata</span><span>Gajendra Mehra</span>7428190590 </li>
            <li><span>Chennai</span><span>Shankar Nambiar</span>8939657946</li>
            <li><span>Hyderabad </span><span>Sunil Chandar</span>9966601515</li>
            <li><span>Pune</span><span>AK Naveen</span>9319292009</li>
            <li><span>Ahmedabad</span><span>Amit Sharma</span>9898836656</li>
          </ul>
          </div>
          </div>
          </div>
    </Container>
    </div>
    </>
  )
}

export default ProjectsAtOrientbell;